import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { userState } from "../../../states/userState";
import { User } from "../../../types";
import { setUserToLocalStorage } from "../../../utils/functions/localStorageManager";
import classes from "./DiaryMatrix.module.scss";
import HeaderController from "../../matrix/organizms/HeaderController";
import DisplayArea from "../../matrix/displayArea/DisplayArea";
import { WorkerForMatrix } from "../../../types/dirary";
const DiaryMatrix = () => {
  const [user, setUser] = useRecoilState(userState);
  const [workerList, setWorkerList] = useState<WorkerForMatrix[]>([]);
  useEffect(() => {
    setUser((prevUser: User) => {
      const newUser: User = {
        ...prevUser,
        initialParameters: {
          ...prevUser.initialParameters,
          latestUrl: "/matrix",
        },
      };
      setUserToLocalStorage(newUser);
      return newUser;
    });
  }, []);
  return (
    <Box
      sx={{
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <HeaderController workerList={workerList} setWorkerList={setWorkerList} />
      <DisplayArea />
    </Box>
  );
};

export default DiaryMatrix;
